import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var ExternalIdentifierTypeDtoNameInline;
(function (ExternalIdentifierTypeDtoNameInline) {
    ExternalIdentifierTypeDtoNameInline["INT64"] = "INT64";
})(ExternalIdentifierTypeDtoNameInline || (ExternalIdentifierTypeDtoNameInline = {}));
export var EntityType;
(function (EntityType) {
    EntityType["ACCOUNT"] = "ACCOUNT";
    EntityType["CONTACT"] = "CONTACT";
})(EntityType || (EntityType = {}));
export var CampaignPositionType;
(function (CampaignPositionType) {
    CampaignPositionType["DIGITAL"] = "DIGITAL";
    CampaignPositionType["PRINT"] = "PRINT";
    CampaignPositionType["RADIO"] = "RADIO";
    CampaignPositionType["TV"] = "TV";
    CampaignPositionType["POSTNETZ_ANALOG"] = "POSTNETZ_ANALOG";
    CampaignPositionType["POS"] = "POS";
    CampaignPositionType["CONSULTING"] = "CONSULTING";
})(CampaignPositionType || (CampaignPositionType = {}));
export var MailchimpStatus;
(function (MailchimpStatus) {
    MailchimpStatus["SUBSCRIBED"] = "SUBSCRIBED";
    MailchimpStatus["UNSUBSCRIBED"] = "UNSUBSCRIBED";
    MailchimpStatus["CLEANED"] = "CLEANED";
    MailchimpStatus["NOT_SYNC"] = "NOT_SYNC";
})(MailchimpStatus || (MailchimpStatus = {}));
export var Invoicing;
(function (Invoicing) {
    Invoicing["NONE"] = "NONE";
    Invoicing["AFTER_RUNTIME"] = "AFTER_RUNTIME";
    Invoicing["START_RUNTIME"] = "START_RUNTIME";
    Invoicing["IMMEDIATELY"] = "IMMEDIATELY";
    Invoicing["CREDIT"] = "CREDIT";
    Invoicing["BY_DELIVERY_500"] = "BY_DELIVERY_500";
    Invoicing["BY_POSITION_END_DATE"] = "BY_POSITION_END_DATE";
    Invoicing["BY_POSITION_END_DATE_MONTH"] = "BY_POSITION_END_DATE_MONTH";
    Invoicing["BY_POSITION_END_DATE_QUARTER"] = "BY_POSITION_END_DATE_QUARTER";
    Invoicing["BY_POSITION_END_DATE_HALFYEAR"] = "BY_POSITION_END_DATE_HALFYEAR";
})(Invoicing || (Invoicing = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender || (Gender = {}));
export var FormOfCommunication;
(function (FormOfCommunication) {
    FormOfCommunication["INFORMAL"] = "INFORMAL";
    FormOfCommunication["FORMAL"] = "FORMAL";
})(FormOfCommunication || (FormOfCommunication = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var InvoiceDeliveryType;
(function (InvoiceDeliveryType) {
    InvoiceDeliveryType["POSTAL"] = "POSTAL";
    InvoiceDeliveryType["DIGITAL"] = "DIGITAL";
})(InvoiceDeliveryType || (InvoiceDeliveryType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["YEARLY_DISCOUNT"] = "YEARLY_DISCOUNT";
    DiscountType["CONSULTANCY_COMMISSION"] = "CONSULTANCY_COMMISSION";
    DiscountType["BROKER_COMMISSION"] = "BROKER_COMMISSION";
    DiscountType["DBE_DISCOUNT"] = "DBE_DISCOUNT";
    DiscountType["EARLY_PAYMENT_COMMISSION"] = "EARLY_PAYMENT_COMMISSION";
})(DiscountType || (DiscountType = {}));
export var LockedEntityType;
(function (LockedEntityType) {
    LockedEntityType["ACCOUNT"] = "ACCOUNT";
    LockedEntityType["CONTACT"] = "CONTACT";
})(LockedEntityType || (LockedEntityType = {}));
export var AccountFormFields;
(function (AccountFormFields) {
    AccountFormFields["NAME"] = "NAME";
    AccountFormFields["INVOICE_NAME"] = "INVOICE_NAME";
    AccountFormFields["ROLES"] = "ROLES";
    AccountFormFields["ADDITIONAL_NAME"] = "ADDITIONAL_NAME";
    AccountFormFields["SHORT_NAME"] = "SHORT_NAME";
    AccountFormFields["PARENT_ACCOUNT_ID"] = "PARENT_ACCOUNT_ID";
    AccountFormFields["INDUSTRY_ID"] = "INDUSTRY_ID";
    AccountFormFields["FOUNDING_YEAR"] = "FOUNDING_YEAR";
    AccountFormFields["XANDR_ADVERTISER_ID"] = "XANDR_ADVERTISER_ID";
    AccountFormFields["GAM_ADVERTISER_ID"] = "GAM_ADVERTISER_ID";
    AccountFormFields["ACTIVE"] = "ACTIVE";
    AccountFormFields["PHONE"] = "PHONE";
    AccountFormFields["CREATIVE_MAIL_ADDRESSES"] = "CREATIVE_MAIL_ADDRESSES";
    AccountFormFields["INVOICE_MAIL_ADDRESSES"] = "INVOICE_MAIL_ADDRESSES";
    AccountFormFields["SCREENSHOT_MAIL_ADDRESSES"] = "SCREENSHOT_MAIL_ADDRESSES";
    AccountFormFields["REPORT_MAIL_ADDRESSES"] = "REPORT_MAIL_ADDRESSES";
    AccountFormFields["STREET_LINE1"] = "STREET_LINE1";
    AccountFormFields["STREET_LINE2"] = "STREET_LINE2";
    AccountFormFields["STREET_LINE3"] = "STREET_LINE3";
    AccountFormFields["STREET_NAME"] = "STREET_NAME";
    AccountFormFields["STREET_NUMBER"] = "STREET_NUMBER";
    AccountFormFields["ZIP_CODE"] = "ZIP_CODE";
    AccountFormFields["CITY"] = "CITY";
    AccountFormFields["COUNTRY_CODE"] = "COUNTRY_CODE";
    AccountFormFields["POSTAL_STREET_NAME"] = "POSTAL_STREET_NAME";
    AccountFormFields["POSTAL_STREET_NUMBER"] = "POSTAL_STREET_NUMBER";
    AccountFormFields["POSTAL_STREET_LINE1"] = "POSTAL_STREET_LINE1";
    AccountFormFields["POSTAL_STREET_LINE2"] = "POSTAL_STREET_LINE2";
    AccountFormFields["POSTAL_STREET_LINE3"] = "POSTAL_STREET_LINE3";
    AccountFormFields["POSTAL_ZIP_CODE"] = "POSTAL_ZIP_CODE";
    AccountFormFields["POSTAL_CITY"] = "POSTAL_CITY";
    AccountFormFields["POSTAL_COUNTRY_CODE"] = "POSTAL_COUNTRY_CODE";
    AccountFormFields["VAT_NUMBER"] = "VAT_NUMBER";
    AccountFormFields["EXCLUDE_MWST"] = "EXCLUDE_MWST";
    AccountFormFields["DISCOUNT"] = "DISCOUNT";
    AccountFormFields["BROKER_COMMISSION"] = "BROKER_COMMISSION";
    AccountFormFields["AGENCY_COMMISSION"] = "AGENCY_COMMISSION";
    AccountFormFields["DBE_COMMISSION"] = "DBE_COMMISSION";
    AccountFormFields["EARLY_PAYMENT_COMMISSION"] = "EARLY_PAYMENT_COMMISSION";
    AccountFormFields["TRADING_FEE"] = "TRADING_FEE";
    AccountFormFields["SALES_CONTACT_ID"] = "SALES_CONTACT_ID";
    AccountFormFields["CLASSIFIEDS_SALES_CONTACT_ID"] = "CLASSIFIEDS_SALES_CONTACT_ID";
    AccountFormFields["DEFAULT_AGENCY_ACCOUNT_ID"] = "DEFAULT_AGENCY_ACCOUNT_ID";
    AccountFormFields["DEFAULT_AGENCY_CONTACT_ID"] = "DEFAULT_AGENCY_CONTACT_ID";
    AccountFormFields["DEFAULT_BROKER_ACCOUNT_ID"] = "DEFAULT_BROKER_ACCOUNT_ID";
    AccountFormFields["DEFAULT_BROKER_CONTACT_ID"] = "DEFAULT_BROKER_CONTACT_ID";
    AccountFormFields["DEFAULT_ACCOUNT_CONTACT_ID"] = "DEFAULT_ACCOUNT_CONTACT_ID";
    AccountFormFields["COMMENT"] = "COMMENT";
    AccountFormFields["IMPORTANT_COMMENT"] = "IMPORTANT_COMMENT";
    AccountFormFields["WEBSITE_LINK"] = "WEBSITE_LINK";
    AccountFormFields["BROKER_OR_AGENCY_COMMISSION_INFO"] = "BROKER_OR_AGENCY_COMMISSION_INFO";
    AccountFormFields["INTERNAL"] = "INTERNAL";
    AccountFormFields["WEBSITE_TARGETING_IDS"] = "WEBSITE_TARGETING_IDS";
    AccountFormFields["WEBSITE_TARGETING_MODE"] = "WEBSITE_TARGETING_MODE";
    AccountFormFields["REGION_TARGETINGS"] = "REGION_TARGETINGS";
    AccountFormFields["INCLUDED_LANGUAGE_IDS"] = "INCLUDED_LANGUAGE_IDS";
    AccountFormFields["CONTEXTUAL_TARGETINGS"] = "CONTEXTUAL_TARGETINGS";
    AccountFormFields["NEGATIVE_CONTEXTUAL_TARGETINGS"] = "NEGATIVE_CONTEXTUAL_TARGETINGS";
    AccountFormFields["IAB3_CATEGORY_TARGETING_IDS"] = "IAB3_CATEGORY_TARGETING_IDS";
    AccountFormFields["NEGATIVE_IAB3_CATEGORY_TARGETING_IDS"] = "NEGATIVE_IAB3_CATEGORY_TARGETING_IDS";
    AccountFormFields["SENTIMENT_TARGETINGS"] = "SENTIMENT_TARGETINGS";
    AccountFormFields["NEGATIVE_SENTIMENT_TARGETINGS"] = "NEGATIVE_SENTIMENT_TARGETINGS";
    AccountFormFields["PAYMENT_PERIOD_DAYS"] = "PAYMENT_PERIOD_DAYS";
    AccountFormFields["EARLY_PAYMENT_PERIOD_DAYS"] = "EARLY_PAYMENT_PERIOD_DAYS";
    AccountFormFields["FIRST_REMINDER_DAYS"] = "FIRST_REMINDER_DAYS";
    AccountFormFields["SECOND_REMINDER_DAYS"] = "SECOND_REMINDER_DAYS";
    AccountFormFields["THIRD_REMINDER_DAYS"] = "THIRD_REMINDER_DAYS";
    AccountFormFields["PERSONAL_CALL_REMINDER_DAYS"] = "PERSONAL_CALL_REMINDER_DAYS";
    AccountFormFields["INVOICE_DELIVERY_TYPE"] = "INVOICE_DELIVERY_TYPE";
    AccountFormFields["INVOICING"] = "INVOICING";
    AccountFormFields["EXTERNAL_REFERENCE"] = "EXTERNAL_REFERENCE";
    AccountFormFields["DEFAULT_REFERENCE"] = "DEFAULT_REFERENCE";
    AccountFormFields["REPORTING_TYPE"] = "REPORTING_TYPE";
    AccountFormFields["COMPANY_DISCOUNT_IDS"] = "COMPANY_DISCOUNT_IDS";
    AccountFormFields["ACCOUNT_TYPE_ID"] = "ACCOUNT_TYPE_ID";
    AccountFormFields["CONTRACT_EXPIRY_DATE"] = "CONTRACT_EXPIRY_DATE";
    AccountFormFields["CONTRACT_LINK"] = "CONTRACT_LINK";
    AccountFormFields["RESET_CONDITIONS_UPON_EXPIRY"] = "RESET_CONDITIONS_UPON_EXPIRY";
})(AccountFormFields || (AccountFormFields = {}));
export var ContactFormFields;
(function (ContactFormFields) {
    ContactFormFields["FIRST_NAME"] = "FIRST_NAME";
    ContactFormFields["LAST_NAME"] = "LAST_NAME";
    ContactFormFields["EMAIL"] = "EMAIL";
    ContactFormFields["GENDER"] = "GENDER";
    ContactFormFields["BIRTH_DATE"] = "BIRTH_DATE";
    ContactFormFields["STREET_LINE1"] = "STREET_LINE1";
    ContactFormFields["STREET_LINE2"] = "STREET_LINE2";
    ContactFormFields["STREET_LINE3"] = "STREET_LINE3";
    ContactFormFields["STREET_NAME"] = "STREET_NAME";
    ContactFormFields["STREET_NUMBER"] = "STREET_NUMBER";
    ContactFormFields["CITY"] = "CITY";
    ContactFormFields["ZIP_CODE"] = "ZIP_CODE";
    ContactFormFields["COUNTRY_CODE"] = "COUNTRY_CODE";
    ContactFormFields["POSTAL_STREET_NAME"] = "POSTAL_STREET_NAME";
    ContactFormFields["POSTAL_STREET_NUMBER"] = "POSTAL_STREET_NUMBER";
    ContactFormFields["POSTAL_STREET_LINE1"] = "POSTAL_STREET_LINE1";
    ContactFormFields["POSTAL_STREET_LINE2"] = "POSTAL_STREET_LINE2";
    ContactFormFields["POSTAL_STREET_LINE3"] = "POSTAL_STREET_LINE3";
    ContactFormFields["POSTAL_ZIP_CODE"] = "POSTAL_ZIP_CODE";
    ContactFormFields["POSTAL_CITY"] = "POSTAL_CITY";
    ContactFormFields["POSTAL_COUNTRY_CODE"] = "POSTAL_COUNTRY_CODE";
    ContactFormFields["PHONE"] = "PHONE";
    ContactFormFields["PHONE_MOBILE"] = "PHONE_MOBILE";
    ContactFormFields["ACTIVE"] = "ACTIVE";
    ContactFormFields["FUNCTION"] = "FUNCTION";
    ContactFormFields["COMMENT"] = "COMMENT";
    ContactFormFields["LANGUAGE"] = "LANGUAGE";
    ContactFormFields["DIVISION"] = "DIVISION";
    ContactFormFields["FORM_OF_COMMUNICATION"] = "FORM_OF_COMMUNICATION";
    ContactFormFields["ROLE"] = "ROLE";
    ContactFormFields["INHERIT_ADDRESS_FROM_ACCOUNT"] = "INHERIT_ADDRESS_FROM_ACCOUNT";
})(ContactFormFields || (ContactFormFields = {}));
export var EmailAddressType;
(function (EmailAddressType) {
    EmailAddressType["SCREENSHOT"] = "SCREENSHOT";
    EmailAddressType["REPORT"] = "REPORT";
    EmailAddressType["INVOICE"] = "INVOICE";
    EmailAddressType["CREATIVE"] = "CREATIVE";
    EmailAddressType["SUGGESTION"] = "SUGGESTION";
})(EmailAddressType || (EmailAddressType = {}));
export var ContactRole;
(function (ContactRole) {
    ContactRole["SALES"] = "SALES";
    ContactRole["CUSTOMER"] = "CUSTOMER";
})(ContactRole || (ContactRole = {}));
export var AccountRole;
(function (AccountRole) {
    AccountRole["ADVERTISER"] = "ADVERTISER";
    AccountRole["BROKER"] = "BROKER";
    AccountRole["AGENCY"] = "AGENCY";
    AccountRole["OTHER"] = "OTHER";
    AccountRole["PUBLISHER"] = "PUBLISHER";
})(AccountRole || (AccountRole = {}));
export var ImportStatus;
(function (ImportStatus) {
    ImportStatus["PROCESSING"] = "PROCESSING";
    ImportStatus["SUCCESS"] = "SUCCESS";
    ImportStatus["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ImportStatus["IMPORT_ERROR"] = "IMPORT_ERROR";
})(ImportStatus || (ImportStatus = {}));
export var ReportingType;
(function (ReportingType) {
    ReportingType["WEEKLY"] = "WEEKLY";
    ReportingType["BY_END_DATE"] = "BY_END_DATE";
    ReportingType["FLIGHT_EXPIRATION"] = "FLIGHT_EXPIRATION";
    ReportingType["MANUAL"] = "MANUAL";
})(ReportingType || (ReportingType = {}));
export var AmountType;
(function (AmountType) {
    AmountType["GROSS1"] = "GROSS1";
    AmountType["GROSS2"] = "GROSS2";
    AmountType["GROSS3"] = "GROSS3";
    AmountType["NET1"] = "NET1";
    AmountType["NET2"] = "NET2";
    AmountType["NET3"] = "NET3";
    AmountType["NET4"] = "NET4";
})(AmountType || (AmountType = {}));
export var DiscountContractDateType;
(function (DiscountContractDateType) {
    DiscountContractDateType["PUBLICATION_DATE"] = "PUBLICATION_DATE";
    DiscountContractDateType["POSITION_START_DATE"] = "POSITION_START_DATE";
    DiscountContractDateType["POSITION_END_DATE"] = "POSITION_END_DATE";
})(DiscountContractDateType || (DiscountContractDateType = {}));
export var DiscountContractSumBy;
(function (DiscountContractSumBy) {
    DiscountContractSumBy["PER_ACCOUNT"] = "PER_ACCOUNT";
    DiscountContractSumBy["ALL_ACCOUNTS"] = "ALL_ACCOUNTS";
    DiscountContractSumBy["PER_FAMILY"] = "PER_FAMILY";
})(DiscountContractSumBy || (DiscountContractSumBy = {}));
export var DiscountContractOverrideMode;
(function (DiscountContractOverrideMode) {
    DiscountContractOverrideMode["INCLUDE"] = "INCLUDE";
    DiscountContractOverrideMode["EXCLUDE"] = "EXCLUDE";
})(DiscountContractOverrideMode || (DiscountContractOverrideMode = {}));
